import { Component, Input, OnChanges, output, SimpleChanges } from '@angular/core';
import { OrderOccasion } from '@app/models/order-occasion';
import { Site } from '@app/models/site';

@Component({
  selector: 'app-home-page-collection-tab',
  templateUrl: './home-page-collection-tab.component.html',
  styleUrls: ['./home-page-collection-tab.component.scss'],
  standalone: false
})
export class HomePageCollectionTabComponent implements OnChanges {
  @Input() public noStoresFound: boolean;
  public allCollectionSites: Site[] = [];
  public allDeliverySites: Site[] = [];
  public showNoSitesError: boolean;
  public supportedSites: Site[] = [];

  public onSelection = output<Site>();

  public readonly occasion = OrderOccasion.Collection;

  @Input('sites') private _sites: Site[];
  public selectedStore: Site;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (!changes._sites) {
      return;
    }

    this.showNoSitesError = this._sites.length === 0;
    this.supportedSites = this._sites.filter((x: Site) => x.OccasionsSupported?.includes(OrderOccasion.Collection)).sort((a: Site, b: Site) => a.Name.localeCompare(b.Name));
  }
}
